import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { USERS_PATH_NAME } from './users.constants';
import {
  GetUsersQuerySchema,
  GetUsersResponseSchema,
  ErrorResponseSchema,
} from './users.schema';

export const UsersContract = terraContract
  .prefix(`/${USERS_PATH_NAME}`)
  .router({
    getUsers: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'GET',
        path: '/',
        summary: 'Get users with pagination and filtering',
        description:
          'Retrieve a paginated list of users from the current tenant with optional filtering capabilities',
        inputStructure: 'detailed',
      })
      .input(z.object({ query: GetUsersQuerySchema }))
      .output(GetUsersResponseSchema)
      .errors({
        BAD_REQUEST: { status: 400, data: ErrorResponseSchema },
        UNAUTHORIZED: { status: 401, data: ErrorResponseSchema },
        INTERNAL_SERVER_ERROR: { status: 500, data: ErrorResponseSchema },
      }),
  });
